/* eslint-disable-next-line react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import RenderCheckboxField from '../../../../utils/renderFields/RenderCheckboxField';

/**
 * Formulaire permettant de mettre à jours la déclaration douanière
 * pour chaque produit
 *
 * @param {Object} fields       The Fields object
 * @param {Number} commandIndex Index de la commande actuelle
 */
const RenderStockItem = ({ fields, requiredAttributes }) => (
  <div>
    {fields.map((requiredAttribute, index) => (
      <div key={`${requiredAttribute}.id`}>
        <Field
          name={`${requiredAttribute}.isPresent`}
          label={requiredAttributes[index].name}
          component={RenderCheckboxField}
          displayErrorBeforeSubmit
          fullWidth
        />
      </div>
    ))}
  </div>
);

RenderStockItem.propTypes = {
  fields: PropTypes.object.isRequired,
  requiredAttributes: PropTypes.any.isRequired
};

export default RenderStockItem;
